import { Timestamp } from "firebase/firestore";
import { getFluidImageObject } from "gatsby-transformer-cloudinary/api";
import slugify from "slugify";

export const getRandomInt = (max) => {
    return Math.floor(Math.random() * Math.floor(max));
};

export const generateRandomId = (length) => {
    let result = "";
    const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
    }
    return result;
};

export const updateGlobalData = (object, data) => {
    // updating form data values into their corresponding keys
    const getAllKeys = (o) => {
        Object.keys(o).forEach(function (k) {
            let contains_object =
                Array.isArray(o[k]) &&
                o[k].some((val) => {
                    return typeof val == "object" && !Array.isArray(val);
                });
            if (
                (Array.isArray(o[k]) && !contains_object) ||
                typeof o[k] !== "object" ||
                "set" in o[k]
            ) {
                keys[k] = o;
            } else {
                return getAllKeys(o[k]);
            }
            keys[k] = o;
        });
    };
    var keys = Object.create(null);
    getAllKeys(object);
    Object.keys(data).forEach(function (k) {
        if (keys[k] && k in keys[k]) {
            // check if key for update exist
            keys[k][k] = data[k];
        } else {
            // add it
            object[Object.keys(data)[k]] = data[k];
        }
    });
};

export const generateSlug = (slug) => {
    const slugified = slugify(slug, {
        lower: true, // convert to lower case, defaults to `false`
        strict: true, // strip special characters except replacement, defaults to `false`
    });

    return slugified;
};

export const constructImage = (file) => {
    const baseUrl = process.env.GATSBY_CLOUDINARY_IMAGE_URL;
    const transform = "q_auto,f_auto/"; // https://cloudinary.com/blog/image_optimization_for_websites_beautiful_pages_that_load_quickly
    const filepath = file.filepath + file.filename;
    const ending = transform + filepath;
    const fileExtension = filepath.split(".").pop();

    const selection = {
        thumb: baseUrl + "w_320," + ending,
        small: baseUrl + "w_640," + ending,
        medium: baseUrl + "w_1280," + ending,
        large: baseUrl + "w_1920," + ending,
        original: baseUrl + ending,
    };
    const srcset = [
        `${selection.thumb} 320w`,
        `${selection.small} 640w`,
        `${selection.medium} 1280w`,
        `${selection.large} 1920w`,
        `${selection.original} 2560w`,
    ];

    return {
        fileExtension,
        selection,
        srcset: srcset.join(),
    };
};

export const stripHtmlTags = (html, keepParagraphs = true) => {
    let sanitisedContent;
    if (keepParagraphs) {
        sanitisedContent = html.replace(/<(?!br|\/br|p|\/p).+?>/g, "");
    } else {
        sanitisedContent = html.replace(/<.+?>/g, "");
    }
    return sanitisedContent;
};

// converts entities (eg. &rsquo;) in an html string to a unicode character (eg. ’)
export const decodeHtmlEntities = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.documentElement.textContent;
};

/**
 * Get a Cloudinary image object with a custom domain (if it exists) - replaces res.cloudinary.com
 *
 * @param {*} options
 * @returns Promise
 */
export const getFluidImageObjectCustomDomain = (options) => {
    return new Promise((resolve, reject) => {
        getFluidImageObject(options).then((image) => {
            if (process.env.GATSBY_CLOUDINARY_CUSTOM_DOMAIN) {
                const customDomain =
                    process.env.GATSBY_CLOUDINARY_CUSTOM_DOMAIN;
                const newImage = {
                    ...image,
                    src: image.src.replaceAll(
                        "res.cloudinary.com",
                        customDomain
                    ),
                    srcSet: image.srcSet.replaceAll(
                        "res.cloudinary.com",
                        customDomain
                    ),
                };
                resolve(newImage);
            } else {
                resolve(image);
            }
        });
    });
};

/**
 * Format a Date object as a string in the format "17 Feb 2023 8:43 am".
 *
 * @param {Date} date
 *
 * @returns {string}
 */
export const formatDate = (date) => {
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];

    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let ampm = hour >= 12 ? "pm" : "am";

    hour = hour % 12;
    hour = hour ? hour : 12; // the hour '0' should be '12'
    minute = minute < 10 ? "0" + minute : minute;

    return `${day} ${months[monthIndex]} ${year} ${hour}:${minute} ${ampm}`;
};

/**
 * Format a Firestore Timestamp as a string in the format "17 Feb 2023 8:43 am".
 *
 * @param {Timestamp} timestamp
 *
 * @returns {string|undefined}
 */
export const formatTimestamp = (timestamp) => {
    if (timestamp?.toDate) {
        return formatDate(timestamp.toDate());
    } else {
        return undefined;
    }
};
